<div class="form-group">
  <label translate>Time Period</label>
  <scitis-required-field-indicator></scitis-required-field-indicator>

  <div class="input-group">
    <input (change)="onTimePeriodChange()"
      [(ngModel)]="timePeriod"
      [max]="MAX_INTERVAL_MINUTES"
      [min]="MIN_INTERVAL_MINUTES"
           [ngClass]="{
                      'is-invalid': isInvalidValue,
                       'is-valid':!isInvalidValue
                       }"
      [placeholder]="'Enter time period ...'|translate"
      [disabled]="disabled()"
      class="form-control"

      type="number">
      <div class="input-group-append">
        <span class="input-group-text" translate>min.</span>
      </div>
      @if (isInvalidValue) {
        <div class="invalid-feedback">
          <span [innerHTML]="warningMessage"></span>
        </div>
      }
    </div>
  </div>
